//const localIp = 'localhost'
 const localIp = 'quizserver.vityazgroup.ru'

export const config = {

    SERVER_SOCKET:`ws://${localIp}:8326`,
    URL_API:`http://${localIp}:8325/api/`,

}